// Los pallets del inventario inicial de bodega llevan, además del número que
// genera el sistema, la identificación con la que bodega los conoce
// físicamente: INI-125-2026 (PALLET-5647/2025). Los pallets de producción no
// tienen identificador, así que se muestra solo su número.
export const formatPalletLabel = (numero, identificadorFisico) => {
    if (!numero) return "";

    if (!identificadorFisico) return numero;

    // desde que el inventario inicial conserva el número real del pallet, el
    // identificador ya viene dentro del número y repetirlo no aporta nada
    if (numero.indexOf(identificadorFisico) !== -1) return numero;

    return `${numero} (${identificadorFisico})`;
};
